import { useMutation, useQuery, UseQueryOptions } from 'react-query';
import { Treatment } from './models/treatment.model';
import { treatmentsService } from '../services/treatments.service';

export function useTreatmentsQuery() {
    return useQuery<Treatment[]>(["treatments"], () =>
        treatmentsService.getAllActive());
}

export function useAddTreatmentMutation() {
    return useMutation((request: Treatment) => treatmentsService.add(request));
}

export function useEditTreatmentMutation() {
    return useMutation((request: Treatment) => treatmentsService.edit(request));
}

export function useDeleteTreatmentMutation() {
    return useMutation((id: number) => treatmentsService.delete(id));
}

export function useTreatmentsByHorseQuery(id: number) {
    const queryOptions: UseQueryOptions<Treatment[]> = {
        enabled: !(!id)
    }

    return useQuery<Treatment[]>(
        ["treatments-horses", id],
        () => treatmentsService.getAllActiveByHorse(id),
        queryOptions
    )
}

export function useTreatmentsByDateQuery(date: Date) {
    const queryOptions: UseQueryOptions<Treatment[]> = {
        enabled: !!date
    }

    return useQuery<Treatment[]>(
        ["treatments-date", date.toISOString()],
        () => treatmentsService.getAllActiveByDate(date),
        queryOptions
    )
}
